angular.module('aprima-core-ui').directive('affix', function () {
    'use strict';
    return {
        restrict: 'A',
        link: function (scope, element) {
            //element is already a jquery or jqlite object
            element.affix({
                offset: {
                    top: 95
                }
            });
        }
    };
});
